import { type PageContext, _ } from '@zto/zpage'
import { commonOptions, EnableStatus, TdlDeviceType } from '@/config'
import { filterSubmitData } from '@/utils'

// 新增/编辑对话框
export const addEditDialog = (isEdit: Boolean) => {
  return {
    width: 600,
    labelWidth: 100,
    itemSpan: 24,

    onShow: async ({ app, data }: PageContext) => {
      const payload = { ...data }

      if (data.manufacturerCode) {
        const res = await app.request({
          api: '/sys/admin/device/manufacturer/listEnabled',
          params: { manufacturerCode: data.manufacturerCode }
        })

        const mfrList = res?.data || []

        const mfrInfo = mfrList.find((it: any) => it.manufacturerCode === data.manufacturerCode)
        payload._supplyScopeCodes = mfrInfo?.supplyScopeCodes || []
      }

      delete payload.refDeviceCount

      return { payload }
    },

    beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
      const payload = filterSubmitData(data)

      if (payload.deviceTypeCode !== TdlDeviceType.TRUNK) {
        delete payload.cabinSize
        delete payload.cellTemplateCode
        delete payload.cellTemplateName
      }

      return payload
    },

    formItems: [
      {
        label: '厂商',
        prop: 'manufacturerCode',
        type: 'fuzzy-select',
        labelProp: 'manufacturerName',
        api: '/sys/admin/device/manufacturer/listEnabled',
        optionValueProp: 'manufacturerCode',
        optionLabelProp: 'manufacturerName',
        onChange: (model: any, a: any, b: any, source: any) => {
          model._supplyScopeCodes = source.option.supplyScopeCodes
        },
        triggerFocus: true,
        required: true
      },
      { type: 'input', prop: 'modelName', label: '型号名称', maxlength: 20, trim: true, required: true },
      {
        type: 'input',
        label: '型号编码',
        prop: 'modelCode',
        placeholder: '请输入型号编码，不填写自动生成',
        maxlength: 20,
        trim: true,
        disabled: isEdit
      },
      {
        type: 'select',
        prop: 'deviceTypeCode',
        labelProp: 'deviceTypeName',
        label: '实体类型',
        required: true,
        dynamicAttrs: ({ data }: PageContext) => {
          if (!data.manufacturerCode) {
            data.deviceTypeCode = ''
            data.deviceTypeName = ''
            return { disabled: true }
          }

          const supplyScopeCodes = data._supplyScopeCodes || []
          if (data.deviceTypeCode && !supplyScopeCodes.includes(data.deviceTypeCode)) {
            supplyScopeCodes.push(data.deviceTypeCode)
          }

          const options = commonOptions.tdlDeviceType.filter(it => supplyScopeCodes.includes(it.value))

          return { options }
        }
      },
      {
        label: '格口模板',
        type: 'fuzzy-select',
        api: '/sys/admin/device/cell-template/listEnabled',
        prop: 'cellTemplateCode',
        labelProp: 'cellTemplateName',
        optionValueProp: 'templateCode',
        optionLabelProp: 'templateName',
        triggerFocus: true,
        tip: { type: 'html', html: '<div class="text-warning">型号创建后，格口模板不可修改，请确认无误！</div>' },
        dynamicAttrs: ({ data }: PageContext) => {
          const visible = data.deviceTypeCode === TdlDeviceType.TRUNK
          return { visible, required: visible }
        },
        disabled: isEdit
      },
      {
        type: 'input',
        prop: 'cabinSize',
        label: '舱体尺寸',
        maxlength: 32,
        trim: true,
        dynamicAttrs: ({ data }: PageContext) => {
          const visible = data.deviceTypeCode === TdlDeviceType.TRUNK
          return { visible, required: visible }
        }
      },
      {
        type: 'checkbox',
        prop: 'status',
        checkType: 'radio',
        label: '启用状态',
        options: [
          { label: '启用', value: EnableStatus.ENABLE },
          { label: '停用', value: EnableStatus.DISABLE }
        ],
        required: true
      },
      { type: 'textarea', prop: 'remark', label: '备注', maxlength: 200, showWordLimit: true, autoHeght: true }
    ]
  }
}
